module.exports = __webpack_public_path__ + "media/images/landing/home/button_play-d4fdb3850a1825eafb471433b96466cd.png";